module.exports = __webpack_public_path__ + "img/tic_tac_toe.24b4051e.png";